/**
 * Parse and allow only http(s) URLs. Returns normalized href or null.
 * @param {unknown} value
 * @returns {string|null}
 */
export function getSafeHttpUrl(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  try {
    const parsed = new URL(value.trim());
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return parsed.href;
  } catch (err) {
    return null;
  }
}

/**
 * Allow only https URLs (e.g. SSO IdP redirects).
 * @param {unknown} value
 * @returns {string|null}
 */
export function getSafeHttpsUrl(value) {
  const href = getSafeHttpUrl(value);
  if (!href) {
    return null;
  }

  try {
    return new URL(href).protocol === 'https:' ? href : null;
  } catch (err) {
    return null;
  }
}
